import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import styles from './Auth.module.css';
import { resetPassword } from '../../../api/user/auth';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      return setError('Password must be at least 6 characters.');
    }
    if (password !== confirmPassword) {
      return setError('Passwords do not match.');
    }

    setIsLoading(true);
    try {
      await resetPassword(token, password);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.message || 'Failed to reset password. The link may have expired.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.backgroundAnimation}></div>

      <div className={`${styles.authCard} ${styles.userCard}`}>
        <div className={styles.authHeader}>
          <div className={styles.authLogo}>SPOTFLI</div>
          <h2 className={styles.authTitle}>Reset Password</h2>
          <p className={styles.authSubtitle}>
            {success ? 'Password reset! Redirecting to login...' : 'Enter your new password below'}
          </p>
        </div>

        {error && (
          <div className={styles.errorMessage}>
            <i className={`fa fa-exclamation-circle ${styles.errorIcon}`}></i>
            {error}
          </div>
        )}

        {success ? (
          <div className={styles.authLinks} style={{ marginTop: 0, paddingTop: 0, borderTop: 'none' }}>
            <i className="fa fa-check-circle" style={{ color: '#1e9ff2', fontSize: '3rem', display: 'block', marginBottom: '16px' }}></i>
            <p style={{ color: '#5b6b78', marginBottom: '20px' }}>Your password has been reset successfully.</p>
            <Link to="/login" className={styles.authLink}>Go to Sign In</Link>
          </div>
        ) : (
          <form className={styles.authForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="password">New Password</label>
              <div className={styles.passwordInputContainer}>
                <input
                  className={styles.formInput}
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Min. 6 characters"
                  required
                />
                <button type="button" className={styles.passwordToggle} onClick={() => setShowPassword(!showPassword)}>
                  <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="confirmPassword">Confirm Password</label>
              <input
                className={styles.formInput}
                type={showPassword ? 'text' : 'password'}
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Repeat new password"
                required
              />
            </div>

            <button className={styles.authButton} type="submit" disabled={isLoading}>
              {isLoading ? 'Resetting...' : 'Reset Password'}
            </button>

            <div className={styles.authLinks}>
              <Link to="/login" className={styles.authLink}>Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
